import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TheaterRoutingModule } from './theater-routing.module';
import { TheaterComponent } from './components/theater/theater.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { CustomFxModule } from 'src/app/core/custom-fx/custom-fx.module';
import { GroupSharingModule } from '../group-sharing/group-sharing.module';


@NgModule({
  declarations: [
    TheaterComponent
  ],
  imports: [
    CommonModule,
    FlexLayoutModule.withConfig({addOrientationBps: true}),
    TheaterRoutingModule,
    SharedModule,
    CustomFxModule,
    GroupSharingModule,
  ],
  exports:[
    TheaterComponent
  ]
})
export class TheaterModule { }
